<!-- 打印首页 -->
<template>
    <div class='app'>
        <INFORMATION :dialogVisible = "dialogVisible" @confirm = "confirm" :oneData="oneData" @cancel="cancel"></INFORMATION>
       <el-container>
            <el-header height='60px'>
                <HEAD step = '0'></HEAD>
            </el-header>
            <el-main>
                <div class="map">
                    <div>
                        <h3>论文打印 低至 <span></span></h3>
                        <span>
                            线上打印 | 包邮配送 | 237万+学生在用
                        </span>
                    </div>
                </div>
                <div class="main">
                    <FLOW index='1'></FLOW>
                    <div class="direct" v-loading="loading" :class="ISupload?'initial':''">
                        <div v-if="ISupload" class="uploadS1">
                            <p>导入文件</p>
                            <div class="directMain1" :class="eldragger? 'eldragger':''">
                                <el-upload
                                    class="upload"
                                    drag
                                    :headers="myHeaders"
                                    accept='.pdf'
                                    :on-success = "uploadSuccess"
                                    :on-error = 'uploadError'
                                    :action="uploadurl"
                                    :data='uploadData'
                                    :before-upload = 'progress'
                                    ref="my-upload"
                                    :disabled = '!upload'
                                    :before-remove = 'remove'>
                                    <div class="tips" v-show="upload">
                                        <img src="../assets/img/PDF.png" alt="PDF">
                                        <div class="el-upload__text">
                                        <!-- 将文件拖拽到此处，或者 -->
                                        <!-- <br> -->
                                        <!-- <span>点击上传</span> -->
                                        </div>
                                        <div class="tipsA" v-show="upload">
                                          <!-- <p>下单流程：上传文件 - 设置打印规格 - 支付</p>
                                          <p>(暂只支持PDF格式文档,单个文件不可超过256M)</p> -->
                                          <p>暂只支持PDF格式文档</p>
                                          <p>单个文件最大不超过256M</p>
                                        </div>
                                    </div>
                                </el-upload>
                            </div>
                        </div>
                        <div v-else class="directMain2">
                            <div class="reintroduce">
                                <el-upload
                                    class="upload2"
                                    accept='.pdf'
                                    :headers="myHeaders"
                                    :show-file-list = 'false'
                                    :action="uploadurl"
                                    :data='uploadData'
                                    :on-success = "uploadSuccess"
                                    :on-error = 'uploadError'
                                    :before-upload = 'progress2'
                                    ref="my-upload"
                                    :before-remove = 'remove'>
                                    <el-button>
                                        添加文件
                                    </el-button>
                                </el-upload>
                                <span>注：暂只支持PDF格式文档,单个文件不可超过256M</span>
                            </div>
                            <div class="h3">
                                <b></b>
                                <p>文件信息 <span class="allFiles">共{{tableData.length}}份文件</span></p>
                            </div>
                            <div class="Table">
                                  <el-table
                                    :data="tableData"
                                    height="250"
                                    style="width: 100%">
                                    <el-table-column
                                    label="文件名"
                                    fixed="left"
                                    align="center"
                                    width="260">
                                        <template slot-scope="scope">
                                            <img style="float:left;margin-top: 4px" class="imgUrl" src="../assets/img/pdf3.png" alt="">
                                            <el-tooltip class="item" effect="dark" :content="scope.row.filename" placement="top">
                                                <span style="margin-left: 10px;max-width:75%;float: left; display: block; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                                                    {{ scope.row.filename }}
                                                </span>
                                            </el-tooltip>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                    align="center"
                                    label="页数">
                                        <template slot-scope="scope">
                                            <span>{{scope.row.pages}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                    align="center"
                                    label="纸型">
                                        <template slot-scope="scope">
                                            <span>{{ option.size[scope.row.size-1] }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        label="纸质">
                                        <template slot-scope="scope">
                                            <span>{{ option.quality[scope.row.quality-1] }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        label="颜色">
                                        <template slot-scope="scope">
                                            <span>{{ option.color[scope.row.color-1] }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        label="单双">
                                        <template slot-scope="scope">
                                            <span>{{ option.side[scope.row.side-1] }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        width="120"
                                        label="装订类型">
                                        <template slot-scope="scope">
                                            <span>{{option.binding_type[scope.row.binding_type]}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        width="120"
                                        label="封面">
                                        <template slot-scope="scope">
                                            <!-- 这个的三元判断主要做皮纹纸颜色, 如果是皮纹纸应拼接颜色 -->
                                            <span>{{ scope.row.cover_type==1? option.cover_type[scope.row.cover_type]+'-'+option.cover_color[scope.row.radio-1]:option.cover_type[scope.row.cover_type] }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        width="110"
                                        label="份数">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.number }}份</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                    align="center"
                                    label="金额">
                                        <template slot-scope="scope">
                                            <span style="margin-left: 10px">{{ scope.row.price }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        width="150"
                                        fixed="right"
                                        label="操作">
                                        <template slot-scope="scope">
                                            <el-button class="scopeButton" size="mini" @click="compile(scope.row, scope.$index)">编辑</el-button>
                                            <template>
                                                <el-popconfirm
                                                    confirm-button-text='确定'
                                                    cancel-button-text='取消'
                                                    icon="el-icon-info"
                                                    icon-color="red"
                                                    @confirm = deleteS(scope.$index)
                                                    title="确定要删除文件吗"
                                                    >
                                                    <el-button slot="reference" style="backgroundColor: #ffffff; color: #666" class="scopeButton" size="mini">删除</el-button>
                                                </el-popconfirm>
                                            </template>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                      <div class="fiexBox">
                        <div class="kefu" @click="openKf">联系客服</div>
                        <div class="shouchang" @click="addFavorite">收藏页面</div>
                      </div>
                    </div>
                    <div class="message" id="addressForm" v-show="!ISupload">
                        <div class="characters">
                            <span>
                            <b></b>
                            邮寄地址
                            </span>
                        </div>
                        <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" :hide-required-asterisk="true">
                            <div class="form_top_s">
                                <el-form-item label="姓名" class="form_top" prop="name" label-width="80px">
                                    <el-input :maxlength='25' v-model="ruleForm.name" placeholder="请输入名称"></el-input>
                                </el-form-item>
                                <el-form-item label="手机号" class="form_top" prop="number" label-width="80px">
                                    <el-input v-model.number="ruleForm.number" maxlength="11" placeholder="请输入手机号"></el-input>
                                </el-form-item>
                            </div>
                            <div class="form_select">
                                <el-form-item class="formSelect" label="省市区" prop="province" label-width="80px">
                                    <el-select @change = 'cityPrefecture(ruleForm.province)' v-model="ruleForm.province" placeholder="请选择">
                                        <div class="abb">
                                            <el-option
                                            v-for="item in provinceOptions"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                            </el-option>
                                        </div>
                                    </el-select>
                                    <span>
                                        省
                                    </span>
                                </el-form-item>
                                <el-form-item class="formSelect ormSelect1" label="" prop="city" label-width="0">
                                    <el-select @change = 'districtPrefecture(ruleForm.city)' v-model="ruleForm.city" :disabled="cityOptions.length<=0" placeholder="请选择">
                                        <div class="abb">
                                            <el-option
                                            v-for="item in cityOptions"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                            </el-option>
                                        </div>
                                    </el-select>
                                    <span>
                                        市
                                    </span>
                                </el-form-item>
                                <el-form-item class="formSelect ormSelect1" label="" prop="district" label-width="0">
                                    <el-select  @change = 'streetPrefecture(ruleForm.district)' v-model="ruleForm.district" :disabled='districtOptions.length<=0' placeholder="请选择">
                                        <div class="abb">
                                            <el-option
                                            v-for="item in districtOptions"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                            </el-option>
                                        </div>
                                    </el-select>
                                    <span>
                                        区
                                    </span>
                                </el-form-item>
<!--                                <el-form-item class="formSelect ormSelect1" label="" prop="region" label-width="0">-->
<!--                                    <el-select v-model="ruleForm.street" :disabled='streetOptions.length<=0' placeholder="请选择">-->
<!--                                        <div class="abb">-->
<!--                                            <el-option-->
<!--                                            v-for="item in streetOptions"-->
<!--                                            :key="item.id"-->
<!--                                            :label="item.name"-->
<!--                                            :value="item.id">-->
<!--                                            </el-option>-->
<!--                                        </div>-->
<!--                                    </el-select>-->
<!--                                    <span>-->
<!--                                        街道-->
<!--                                    </span>-->
<!--                                </el-form-item>-->
                            </div>
                            <div>
                                <el-form-item class="particular" label="详细地址" prop="particular" label-width="80px">
                                    <el-input :maxlength='200' v-model="ruleForm.particular" placeholder="请输入详细地址"></el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                </div>
            </el-main>
            <el-footer height='115px' v-show="!ISupload">
                <div class="footer">
                    <div class="left">
                        <p>
                            <span>
                                打印费用
                            </span>
                            <span class="money">
                                ¥{{toDecimal2(sum)}}
                            </span>
                        </p>
                        <p>
                            <span>
                                快递费用
                            </span>
                            <span class="money">
                                ¥{{toDecimal2(sum2)}}
                            </span>
                        </p>
                    </div>
                    <div class="right">
                        <span>
                            应付费用 :
                        </span>
                        <span class="money">
                            <b>
                                ¥
                            </b>
                            {{toDecimal2(sum3)}}
                        </span>
                        <div class="button">
                            <el-button class="nextStep" @click="placeAnOrder('ruleForm')">
                                下一步: 确认支付
                            </el-button>
                        </div>
                    </div>
                </div>
            </el-footer>
            <el-footer class="footerS" v-show="ISupload">
                {{FOOTER}}
            </el-footer>
            <el-dialog title="提示" :visible.sync="dialogVisible2" top="40vh" width="430px">
                <span>请确认文件信息与收货信息无误，下单后不可修改</span>
                <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible2 = false">取 消</el-button>
                <el-button size="small" type="primary" @click="confirms">确 定</el-button>
            </span>
            </el-dialog>
        </el-container>
    </div>
</template>

<script>
import head from '../components/head.vue';
import flow from '../components/flow.vue';
import information from '../components/information.vue';
import common from '../commons/common';
export default {
    components: {
        HEAD: head,
        FLOW: flow,
        INFORMATION: information
    },
    data () {
        var validatorPhone = function (rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入手机号码'))
            } else if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(value)) {
                callback(new Error('请输入正确的手机号'))
            } else {
                callback()
            }
        }
        return {
            toDecimal2:  common.toDecimal2, // 保留两位小数点
			FOOTER: common.FOOTER,
            loading: false, // 上传间隔
            nextStep: true, // 下一步按钮
            deleteIndex: -1,
            upload: true, // 上传状态
            ISupload: true, // 是否显示初始上传组件
            myHeaders: {
               Accept: 'application/json',
            },
            tableData: [], // 表格数据
            filesdata: [], // 多文件计价
            ruleForm: {
                name: '', // 收货人
                number: '', // 手机号码
                particular: '', // 详细地址
                province: '', // 省
                city: '', // 市
                district: '', // 区
                street: '', // 街道
            },
            rules: {
                name: [
                    { required: true, message: '请填写姓名', trigger: 'blur' }
                ],
                number: [
                    { required: true, validator: validatorPhone, trigger: 'blur' },
                ],
                particular: [
                    { required: true, message: '请填写详细地址', trigger: 'blur' }
                ],
                province: [
                    { required: true, message: '请选择省', trigger: 'change' }
                ],
                city: [
                    { required: true, message: '请选择市', trigger: 'change' }
                ],
                district: [
                    { required: true, message: '请选择区', trigger: 'change' }
                ]
            },
            option: {}, // 字典表数据
            provinceOptions: [], // 省下拉框
            cityOptions: [], // 市下拉框
            districtOptions: [], // 区下拉框
            streetOptions: [], // 街道下拉框
            dialogVisible: false, // 控制弹窗是否打开
            dialogVisible2: false, // 确定提交按钮
            oneData:{}, // 传递给编辑弹窗的单条数据
            index: '', // 编辑弹窗修改的第几条数据
            OssData: '',
            priceList: '', // 价格表
            eldragger: false, // 是否提示上传文件
            files: '',
            address: {
                province: "",
                city: "",
                district:''
            }, // 地址拼接
            uploadurl:this.Api.BASEURL + "/an/upload/getFileFid"
        };
    },
    mounted() {
      const unwatch = this.$watch('ISupload', function(newValue, oldValue){
        if(newValue == false){
          this.provincePrefecture()
          unwatch()
        }
      });
    },
    computed:{
        sum:function(){
            if(this.priceList.total) {
                let a = (this.priceList.total-this.priceList.shipping)*0.01
                a =  Math.floor(a * 100) / 100
                return a
            }else {
                return 0
            }
        },
        sum2:function(){
            if(this.priceList.shipping) {
                let a = this.priceList.shipping*0.01
                a =  Math.floor(a * 100) / 100
                return a
            }else {
                return 0
            }
        },
        sum3:function(){
            if(this.priceList.total) {
                let a = this.priceList.total*0.01
                a =  Math.floor(a * 100) / 100
                return a
            }else {
                return 0
            }
        },
        uploadData:function() {
            return {
                'setting[side]':2 // 上传入参使默认双面
            }
        }
    },
    watch:{
        cityOptions(newData){
            if(newData.length == 1){
            this.ruleForm.city = newData[0]
            this.districtPrefecture(newData[0].id)
            }
        }
    },
    created() {
      this.query()   
    },
    methods: {
        async query() {
            let res = await this.Api.querys(0)
            let data = res.data.data
            this.option = {}
            Object.keys(data).forEach((key) => {
                this.option[key] = []
                if(key == 'cover_type' || key == 'binding_type') this.option[key].push(key=='cover_type'?'无需封面':'无需装订')
                Object.keys(data[key]).forEach((keys) => {
                    this.option[key].push(keys)
                })
            })
        },
      fun(){
        document.querySelector('#addressForm').scrollIntoView({
          behavior: "smooth", // 定义动画过渡效果， "auto"或 "smooth" 之一。默认为 "auto"
          block: "center", // 定义垂直方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "start"
          inline: "nearest" // 定义水平方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "nearest"
        })
      },
      dataFor(data) { // 地址整理数据
        let item = []
        for (let i in data) {
          item.push(
            {
              name: i,
              id: data[i]
            }
          )
        }
        return item
      },
      itemFor(data,index,add) {
        for(let i = 0; i<data.length; i++) {
            if(data[i].id == index) this.address[add] = data[i].name
        }
      },
      async provincePrefecture() { // 省级查询
        var res = await this.Api.region(0)
        let data = res.data.data
        this.provinceOptions = this.dataFor(data)
      },
      async cityPrefecture(e) { // 市级查询
        this.itemFor(this.provinceOptions,e,'province')
        this.reset(1)
        var res = await this.Api.region(e)
        let data = res.data.data
        this.cityOptions = this.dataFor(data)
      },
      async districtPrefecture(e) { // 区级查询
        this.itemFor(this.cityOptions,e,'city')
        this.reset(2)
        let res = await this.Api.region(e)
        let data = res.data.data
        this.districtOptions = this.dataFor(data)
      },
      async streetPrefecture(e) { // 街道查询
        this.itemFor(this.districtOptions,e,'district')
        // this.reset(3)
        // let res = await this.Api.region(e)
        // let data = res.data.data
        // this.streetOptions = this.dataFor(data)
      },
      reset(e) {
        if (e <= 3) { // 清空街道
          this.streetOptions = []
          this.ruleForm.street = ''
        }
        if (e <= 2) { // 清空区
          this.districtOptions = []
          this.ruleForm.district = ''
        }
        if (e <= 1) { // 清空市
          this.cityOptions = []
          this.ruleForm.city = ''
        }
      },
      async uploadSuccess(response, file, fileList) {
        this.$refs['my-upload'].clearFiles();
        if (response.code == -1) {
          this.uploadError(response.codeMsg)
          this.loading = false
          return
        }
        this.upload = true
        this.ISupload = false
        this.$message({
          message: '上传成功',
          type: 'success'
        });
        this.loading = false
        let detail = response.data.detail[0]
        // let a = detail.price * 0.01
        // a = Math.floor(a * 100) / 100
        // 文件打印的默认配置
        this.tableData.push({
          filename: detail.name, // 文件名
          size: 1, // 纸型
          number: detail.nums, // 打印数
          price: '获取中...', // 金额
          quality: 1, // 纸质
          color: 1, // 颜色
          side: 2, // 单双
          pages: detail.pages, // 页数
          binding_type: detail.binding, // 订装方式
          cover_type: detail.cover, // 封面
          file_id: detail.file_id, // id
          radio: 2, // 皮纹纸颜色
          cover: '1', // 封面图片方案
          coverS: '',
          cover_backS: '',
        })
        this.valuation()
      },
      coverData(item) {
          if(item.cover_type == 0) return {}
          let cover = {
              "type": item.cover_type, // 封面类型
              "image_type": item.cover, //封面图片类型
          }
          if(item.cover_type == 1) { // 封面颜色，仅皮纹纸(cover.type:1)时支持
              cover.color_id = item.radio // 封面颜色
          }
          if(item.cover == 1) {
              cover.cover = item.coverS // 封面图链接
              cover.cover_back = item.cover_backS // 封底图链接
          }
          return cover
      },
      async valuation(e) { // 计价: 上传后计价, 编辑后也需要计价
        let data = []
        for (let i = 0; i < this.tableData.length; i++) {
          let item = this.tableData[i]
          if (e && i == this.index) item = e // 弹窗修改内容请求
          data.push({
            "file_id": item.file_id, // 唯一id
            "nums": item.number, // 打印份数
            "binding_type": item.binding_type, // 装订类型
            "setting": {
              "size": item.size, // 纸型
              "color": item.color, // 彩色或黑白
              "side": item.side, // 单双面
              "quality": item.quality, // 重量
            },
            "cover": this.coverData(item) // 封面
          })
        }
        this.files = data // 保存数据下单时用
        let res = await this.Api.valuation({
          files: data
        })
        if(res.data.code !== -1){
          let that = this
          res.data.data.detail.forEach((item) => {
            that.tableData.forEach((item1) => {
              if(item.file_id == item1.file_id){
                item1.price = '¥' + this.toDecimal2(Math.floor((item.price*0.01)*100)/100)
              }
            })
          })
        }
        // 编辑后修改表格数据
        if (e) {
          if (res.data.code == -1) {
            this.$message.error('暂不支持此规格');
          } else {
            this.tableData[this.index].number = e.number
            this.tableData[this.index].filename = e.filename
            this.tableData[this.index].size = e.size
            this.tableData[this.index].number = e.number
            let a = res.data.data.detail[this.index].price * 0.01
            a = Math.floor(a * 100) / 100
            this.tableData[this.index].price = '¥' + this.toDecimal2(a)
            this.tableData[this.index].quality = e.quality
            this.tableData[this.index].color = e.color
            this.tableData[this.index].side = e.side
            this.tableData[this.index].pages = e.pages
            this.tableData[this.index].binding_type = e.binding_type
            this.tableData[this.index].cover_type = e.cover_type
            this.tableData[this.index].file_id = e.file_id
            this.tableData[this.index].radio = e.radio
            this.tableData[this.index].cover = e.cover
            this.tableData[this.index].coverS = e.coverS
            this.tableData[this.index].cover_backS = e.cover_backS
            
            let everyPrcie = null
            res.data.data.detail.forEach((item) => {
              everyPrcie += item.price
            })
            res.data.data.total = Number(res.data.data.shipping) +everyPrcie
            this.priceList = res.data.data
          }
        } else {
          let everyPrcie = null
          res.data.data.detail.forEach((item) => {
            everyPrcie += item.price
          })
          res.data.data.total = Number(res.data.data.shipping) +everyPrcie
          this.priceList = res.data.data
        }
      },
      uploadError(e) {
        this.upload = true
        this.$message.error('上传失败');
      },
      progress(file) { // 上传文件1开始上传
        if (file.size > 256 * 1024 * 1024) {
            this.$message.error('文件超过256M，请压缩文件大小后上传');
            return false   //必须返回false
        }
        this.eldragger = false
        this.upload = false
      },
      progress2() { // 上传文件二开始上传
        this.loading = true
        this.upload = false
      },
      remove() { // 取消上传
        this.upload = true
      },
      deleteS(e) { // 删除
        this.tableData.splice(e, 1)
        if (this.tableData.length <= 0) {
          this.ISupload = true
          this.priceList = {}
        } else {
          this.valuation()
        }
      },
      changeActive(e) {
        this.deleteIndex = e
      },
      removeActive() {
        this.deleteIndex = -1
      },
      // 编辑按钮,弹窗打开,赋值,保存修改下标
      compile(e, index) {
        this.dialogVisible = true
        this.oneData = e
        this.index = index
      },
      cancel() { // 弹窗关闭事件
        this.dialogVisible = false
      },
      confirm(e) { // 将弹窗修改的数据赋值
        this.dialogVisible = false
        this.valuation(e)
      },
      // 确认上传按钮
      async confirms() {
        this.dialogVisible2 = false
        let data = {
          region_code: this.ruleForm.district,
          receive_addr: this.address.province + this.address.city + this.address.district + this.ruleForm.particular,
          receive_name: this.ruleForm.name,
          receive_mobi: this.ruleForm.number,
          files: this.files
        }
        try {
            let res = await this.Api.preCreateOne(data)
            if(res.data.code == 200) {
                let resData = res.data.data
                localStorage.setItem('orderData', JSON.stringify(resData));
                this.$router.push({
                    name: 'confirm',
                    params: {
                        orderData: resData
                    }
                })
            }else {
                this.$message.error(res.data.codeMsg || '您的网络不好! 稍后重试');
            }
        } catch (e) {
            this.$message.error('当前无网络');
        }
      },
      placeAnOrder(formName) {
        if (this.ISupload == false) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.dialogVisible2 = true
            } else {
              return false;
            }
          });
        } else {
          this.eldragger = true;
          this.$message.error('至少提交一个打印文件');
        }
        for(let i in this.ruleForm){
          if(!this.ruleForm[i]){
            this.fun()
            return
          }
        }
      },
      openKf(){
        window.open(common.urlKEFU)
      },
      addFavorite(){
		common.addFavorite(this)
      },
    },
}
</script>

<style lang='less' scoped>
    .app {
        width: 100%;
        min-height: 100%;
        font-size: 14px;
        background-color: #f7f7f7;
        height: 100%;
    }
    .el-main {
        margin: 0;
        padding: 0;
    }
    .main {
        height: 80%;
        max-width: 1250px;
        margin: auto;
    }
    .map {
        height: 144px;
        background: #126ead;
        background: url('../assets/img/map.jpg') no-repeat 100% 100%;
        background-size: 100% 100%;
        div {
            max-width: 1250px;
            overflow: hidden;
            width:100%;
            margin: auto;
            font-family: "微软雅黑";
            h3 {
                font-size: 32px;
                color: #fff;
                height: 50px;
                margin-top: 32px;
                margin-bottom: 8px;
                position: relative;
                span {
                    display: inline-block;
                    width: 60px;
                    height: 66px;
                    background: url('../assets/img/mani.png') no-repeat;
                    position: absolute;
                    margin-left: 5px;
                    margin-top: -4px;
                    line-height: 60px;
                    text-align: center;
                    font-size: 24px;
                    color: #fff;
                }
            }
            span {
                color: #c0e1f6;
                font-size: 16px;
            }
        }
    }
    @media (max-width: 1400px){
        .fiexBox{
            display: none;
        }
    }
    .uploadS1 {
        height: 100%;
    }
    .direct {
        background-color: #fff;
        padding: 25px 45px;
        position: relative;
        .h3 {
            font-size: 16px;
            color: #333333;
            b {
                width: 2px;
                height: 18px;
                background-color: #0065d0;
                float: left;
                position: relative;
                top: 12px;
                margin-right: 10px;
            }
        }
        p {
            font-size: 16px;
            color: #333333;
            margin: 0;
            padding: 0;
        }
        .directMain1 {
            height: 90%;
            border-radius: 4px;
            margin-top: 20px;
            font-size: 16px;
            color: #666;
            .upload {
                width: 100%;
                height: 100%;
                text-align: center;
            }
            .tips {
                margin-top: 66px;
                height: 92%;
                img {
                  height: 50%;
                }
                span {
                    color: #18bbff;
                    text-decoration: underline;
                    line-height: 30px;
                }
            }
          .tipsA {
            // margin-top: 14px;
            p{
              font-size: 14px;
              color:#7b7b7b;
              &:first-child {
                margin-bottom: 5px;
              }
            }
          }
            img {
                margin-bottom: 10px;
            }
            /deep/ .el-upload-list {
                position: relative;
                top: -300px;
                width: 50%;
                margin: auto;
            }
            /deep/.el-upload {
                width: 100%;
                height: 100%;
                .el-upload-dragger {
                    width: 100%;
                    height: 100%;
                    border-radius: 4px;
                }
            }
        }
        .directMain2 {
            overflow: hidden;
            p {
                line-height: 40px;
              .allFiles{
                color: #8f8b8b;
                font-size: 14px;
                margin-left: 12px;
              }
            }
            .reintroduce {
                width: 100%;
                margin-bottom: 10px;
                font-size: 12px;
                .el-button{
                    width: 80px;
                    height: 30px;
                    border-radius: 4px;
                    background-color: #0065d0;
                    line-height: 0;
                    padding: 0;
                    color: #fff;
                }
                span {
                    color: #666;
                    margin-left: 5px;
                    line-height: 28px;
                }
                .el-button:hover {
                    background-color: #044285;
                }
            }
            .Table {
                float: left;
                width: 100%;
                height: 250px;
                .imgUrl {
                    position: relative;
                    top: 0px;
                }
                /deep/.el-input__icon {
                    line-height: 24px;
                }
                /deep/.el-input__inner {
                    height: 28px !important;
                }
                .el-input-number--mini {
                    width: 100%;
                }
                /deep/th {
                    background-color: #f9f9f9;
                }
                .overspread {
                    width: 28px;
                    height: 28px;
                    position: absolute;
                    top: 12px;
                    left: 37%;
                    z-index: 1000;
                }
                /deep/.el-table__body-wrapper {
                    height: 80%;
                }
                /deep/.el-table {
                    height: 100%;
                }
            }
          .deleteI{
            cursor: pointer;
          }
        }
    }
    .initial{
        height: 86%;
        min-height: 380px;
      .directMain1{
        .tips{
          margin-top: 90px;
        }
      }
    }
    .message {
        background-color: #fff;
        overflow: hidden;
        margin-top: 20px;
        padding: 30px 0;
        /deep/.el-select {
            width: 80%;
            min-width: 50px;
        }
        .characters {
            width: 12%;
            height: 100%;
            float: left;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            color: #333;
            b {
                width: 2px;
                height: 18px;
                background-color: #0065d0;
                position: relative;
                top: 4px;
                margin-left: 19px;
                display: inline-block;
                margin-right: 4px;
            }
        }
        .el-form {
            width: 88%;
            float: left;
            .form_top {
                width: 22%;
                float: left;
                margin-right: 5%;
            }
            .formSelect {
                float: left;
                margin-right: 2%;
                width: 21%;
                min-width: 130px;
                span {
                    margin-left: 3%;
                }
            }
            .ormSelect1 {
                width: 14%;
            }
            .ormSelect1:nth-last-child(1) {
                width: 15%;
            }
            .form_top_s {
                height: 60px;
            }
            .form_select {
                overflow: hidden;
                height: 60px;
            }
            .particular {
                width: 70%;
            }
        }
    }
    .fiexBox {
      position: absolute;
      top: 240px;
      right: -63px;
    }
    .kefu,.shouchang {
      width: 43px;
      height: 43px;
      border: 1px solid #e7e7e7;
      background: #fff;
      color: #9e9e9e;
      font-size: 12px;
      padding: 4px;
      box-sizing: border-box;
      text-align: center;
      cursor: pointer;
      &:hover{
        background: #0d81fc;
        color: #fff;
      }
    }
    .shouchang{
      margin-top: 10px;
    }
    .el-footer {
        background-color: #fff;
        margin-top: 20px;
        width: 100%;
        // position: absolute;
        // bottom: 0;
        position:sticky;
        bottom: 0;
        .footer {
            max-width: 1250px;
            margin: auto;
            overflow: hidden;
            .left {
                float: left;
                margin-top:22px;
            }
            p {
                margin: 10px 0;
                color: #999999;
                .money {
                    color: #126eac;
                    margin-left: 20px;
                }
            }
            .right {
                float: right;
                line-height: 109px;
                .money {
                    font-size: 30px;
                    color: #126eac;
                    margin-right: 20px;
                    b {
                        font-weight: 400;
                        font-size: 14px;
                    }
                }
                .el-button {
                    width: 157px;
                    height: 40px;
                    background-color: #126eac;
                    color: #fff;
                    // css2
                    background-color: #f8f8f8;
                    color: #bfbfbf;
                }
                .button {
                    float: right;
                }
            }
        }
    }
    /deep/.el-form-item {
        margin-bottom: 0;
    }
    .el-table__row .el-button {
       	width: 50px;
        height: 25px;
        background-color: #0065d0;
        border-radius: 4px;
        line-height: 25px;
        font-size: 12px;
        margin: 0;
        padding: 0;
        color: #fff;
    }

    /deep/.el-input__inner {
        line-height: 35px;
        height: 35px !important;
        font-size: 12px;
    }
    /deep/.el-form-item__error {
        top: 90%;
    }
    /deep/ .el-dialog__body{
      padding: 14px 20px;
    }
    /deep/ .el-dialog__title{
      font-size: 16px;
    }
    .abb {
        max-height: 170px;
    }
    .upload2 {
        float: left;
    }
    .nextStep {
        background-color: #0065d0 !important;
        color: #fff !important;
    }
    .eldragger {
        /deep/.el-upload-dragger {
            border-color: red;
        }
    }
    .footerS {
        margin-top: 0;
        text-align: center;
        line-height: 60px;
        color: #bebebe;
        font-size: 12px;
        background-color: #f7f7f7;
    }
    .el-container {
        height: 100%;
    }
    .el-header {
        background-color: #fff;
    }
    /deep/.el-table .cell {
        display: flex;
        justify-content: center;
    }
</style>




// WEBPACK FOOTER //
// src/pages/index2.vue